import React, { InputHTMLAttributes } from "react";
import { Dictionary, groupBy, map } from "underscore";
import { IThresholdModel } from "../../../models/Threshold.Model";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { CustomTextBox } from "components/shared/CustomTextBox";

interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    data: Array<IThresholdModel>,
    onChangeHandler: any,
}

export const QuestionnaireItem = React.forwardRef(({ data, onChangeHandler, ...rest }: inputProps, ref) => {
    let groupedQuestionaire: Dictionary<IThresholdModel[]> = groupBy(data ?? [], "QuestionnaireTypeName");
    return (
        <Row className="questionarie-item">
            {groupedQuestionaire && map(groupedQuestionaire, (value: Array<IThresholdModel>, index) => {
                const key = value[0].QuestionnaireTypeName;
                return (
                    <Col key={index} lg="4" md="6" xl="4" sm="12" xs="12" className="mb-4">
                        <Card className="" style={{ height: '100%', background: "white" }}>
                            <Row className="pt-3 px-4">
                                <Col lg={10} md={9} xs={9} className="d-flex mt-2">
                                    <h5 className='text-dofy d-flex'><i className="fa fa-tools me-2"></i>{key}</h5>
                                </Col>
                                <Col lg={2} md={3} xs={3}>
                                    <CustomTextBox slot="end" defaultValue={value[0].Threshold} placeholder="0"
                                        onChange={(e) => onChangeHandler(value[0], e.target.value)} label={undefined} id={undefined} error={undefined} />
                                </Col>
                            </Row>
                            <CardBody>
                                {value.map((item: IThresholdModel, iIndex: any) => {
                                    return (
                                        <Row key={iIndex} lines={item.ParentId === 0 ? 'none' : 'inset'}
                                        hidden={item.Type === 'Heading'}>
                                            <Col lg={10} md={9} xs={9} className="d-flex mt-2">
                                           
                                                <h6 className={item.ParentId === 0 || item.AnswerType === 'None'
                                                    ? 'pv_questionnaire_title' : 'pv_questionnaire_name'}>
                                                     <i hidden={item.AnswerType === 'None' || item.ParentId === 0} className="fa fa-caret-right"></i> {item.DisplayName}
                                                </h6>
                                            </Col>
                                            <Col lg={2} md={3} xs={3} slot="end" lines="none" color="transparent" className="m-0 p-0"
                                                hidden={!item.IsEditable}>
                                                <CustomTextBox  defaultValue={item.Threshold} placeholder="0"
                                                    onChange={(e) => onChangeHandler(item, e.target.value)} label={undefined} id={undefined} error={undefined} />
                                            </Col>
                                        </Row>
                                    )
                                }
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                )
            }
            )}
        </Row>
    );
});